const TitleStripe = ({ children, className = "", isGray = false }) => {
  return (
    <div className={`relative w-full mt-10 ${className}`}>
      <div className="absolute inset-0 top-1/2 border-t border-gray-300"></div>
      <div
        className={`relative z-10 inline-block pr-6 text-gray-800 text-base md:text-lg font-semibold tracking-widest uppercase mx-auto ${
          isGray ? "bg-gray-50" : "bg-white"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default TitleStripe;
